import { Outlet } from 'react-router-dom';
import { Container, Center } from '@chakra-ui/react';
import { Toaster } from '@/components/ui/toaster';
import GlobalChatWidget from '@/components/ui/global-chat-widget';

export default function PublicLayout() {
  return (
    <Center minH={'100vh'} py={4} bgColor='secondary.500' className='print-layout'>
      <Container px={{ base: 4, md: '6', lg: '8' }}>
        <Outlet />
        <Toaster />
        <GlobalChatWidget />
      </Container>
    </Center>
  );
}
